import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const changeSubCatSeqAction = createAsyncThunk(
    'change-sub-cat-seq',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/support-server/api/change-sub-cat-seq`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const changeSubCatSeqSlice = createSlice({
    name: 'change-sub-cat-seq',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(changeSubCatSeqAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(changeSubCatSeqAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(changeSubCatSeqAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const changeSubCatSeqReducer = changeSubCatSeqSlice.reducer